import { useEffect, useMemo, useRef, useState } from "react"
import { PointMaterial, Points, shaderMaterial } from "@react-three/drei"
import { useFrame } from "@react-three/fiber"
import { Float32BufferAttribute } from "three"
import { StartBird } from "../start-bird"


const shader = shaderMaterial(
  { time: 0 },
  `
        varying vec2 vUv;
      void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
    `,
  `
      uniform float time;
      varying vec2 vUv;
  
      void main() {
        // Зміна кольору з синього у фіолетовий
        float wave = sin(vUv.x * 10.0 + time) * 0.5 + 0.5;
  
        vec3 color1 = vec3(0.0, 0.0, 1.0); // Синій
        vec3 color2 = vec3(0.5, 0.0, 0.5); // Фіолетовий
  
        vec3 color = mix(color1, color2, wave);
        gl_FragColor = vec4(color, 1.0);
      }
    `,
)

const createPoints = (count) => {
  const positions = []
  for (let i = 0; i < count; i++) {
    positions.push([
      (Math.random() / 10) - 0.05,
      -(0.05 + Math.random()) / 10,
      (Math.random() / 10) - 0.05
    ])
  }
  return positions
}
const RocketParticles = ({model}) => {
  const pointsRef = useRef()
  const prevYRef = useRef(model.nodes["start_rocket"].position.y);
  const count = 200
  const positions = useMemo(() => {
    const positions = new Float32Array(count * 3)
    for (let i = 0; i < count; i++) {
      positions[i * 3] = (Math.random() - 0.5) * 0.07 // X
      positions[i * 3 + 1] = -Math.random() * 0.5    // Y
      positions[i * 3 + 2] = (Math.random() - 0.5) * 0.07 // Z
    }
    return positions
  }, [count])


  useFrame(({ clock },delta) => {
    const time = Math.sin(clock.getElapsedTime() * 2)
    const currentY = model.nodes["start_rocket"].position.y;

    // Determine rocket movement direction
    const isMoveUp = currentY > prevYRef.current;

    pointsRef.current.visible = isMoveUp ? time < 0.5 : time < -0.95

    //pointsRef.current.parent.position.copy(model.nodes["start_rocket"].position);
    //pointsRef.current.parent.position.y -= 0.15;

    const positions = pointsRef.current.geometry.attributes.position.array
    for (let i = 0; i < count; i++) {
      // Перезапуск частинки
      if (positions[i * 3 + 1] < -0.4) {
        positions[i * 3 + 1] = 0
        positions[i * 3 + 2] = 0
        positions[i * 3 + 3] = 0
      } else {
        positions[i * 3 + 1] -= delta * 0.1// Рух частинок вниз
        positions[i * 3 + 2] -= (-0.5 + Math.random()) / 300 // Рух частинок вниз
        positions[i * 3 + 3] -= (-0.5 + Math.random()) / 300 // Рух частинок вниз
      }
    }
    pointsRef.current.geometry.attributes.position.needsUpdate = true
    prevYRef.current = currentY;
  })

  return (
    <group position={[-14.085, 1.22, -1.66]}>
      <Points ref={pointsRef} positions={positions}>
        <PointMaterial
          transparent
          color="#fff"
          size={0.04}
          sizeAttenuation
          depthWrite={false}
        />
      </Points>
    </group>
  )
}

const StartRocket = ({ model }) => {
  const mapRef = useRef();
  const flagRef = useRef();
  const RainbowMaterial = useMemo(() => shader, [])

  useEffect(() => {
    model.nodes["start_rocket_dec"].children[1].material = new RainbowMaterial()
  }, [model])

  useFrame(({ clock }) => {
    // Левітація вгору-вниз
    const elapsedTime = clock.getElapsedTime()
    model.nodes["start_rocket"].position.y = 1.15 + Math.sin(elapsedTime * 2) * 0.2
    // Обертання навколо своєї осі
    model.nodes["start_rocket"].rotation.y += 0.03
    // Оновлення часу для шейдера
    model.nodes["start_rocket_dec"].children[1].material.time = elapsedTime
  })


  return (
    <>
      <primitive object={model.nodes["start_rocket"]} />
      <primitive object={model.nodes["start_rocket_dec"]} />


      <RocketParticles model={model} />
    </>
  )
}


export {
  StartRocket,
}